import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from "react-router-dom";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import { getStoredItem, setStoredItem } from "../../store/dataStore";

import verification from "../../api/verification";
import limitsApi from "../../api/limits";
import reports from "../../api/reports";

import { LIMITS_STORAGE_NAME } from "../../store/constants";
import { dateFormatter } from "../../util/formatter";
import ApproveOrRejectGroup from "./ApproveOrRejectGroup";
import { handleError } from "@/util/errorHandler";

export class WaitingForApproveDesktop extends Component {
  constructor(props) {
    super(props);

    // Using localStorage instead of global state manager 😄
    const limitsList = getStoredItem(LIMITS_STORAGE_NAME);

    this.state = {
      limitsList: limitsList ? JSON.parse(limitsList) : [],
    };
  }

  componentDidMount() {
    this.loadOrTakeFromCacheLimitsList();
  }

  loadOrTakeFromCacheLimitsList = () => {
    if (this.state.limitsList.length === 0) {
      limitsApi
        .getLimitsListAll()
        .then(limitsList => {
          setStoredItem(LIMITS_STORAGE_NAME, JSON.stringify(limitsList));
          this.setState({ limitsList });
        })
        .catch(handleError);
    }
  };

  table = React.createRef();

  headerStyle = {
    backgroundColor: "#D15050",
    color: "white",
  };

  viewFormatter = (cell, row) => (
    <Link
      to={{
        pathname: `/customer_kyc_info/${cell}`,
        state: { data: row },
      }}>
      <div>
        <i
          className="fa fa-search"
          style={{ color: "#D15050" }}
          data-cy="view-tx"
        />
      </div>
    </Link>
  );

  approveRejectFormatter = (verificationId, row) => {
    const { limitsList } = this.state;

    return (
      <ApproveOrRejectGroup
        limitsList={limitsList}
        verificationId={verificationId}
        accountType={row.accountType}
        requestStatus={row.requestStatus}
        callback={this.table.handleUpdateCurrentPage}
      />
    );
  };

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Waiting for Approval (Desktop)</CardHeader>
              <CardBody>
                <TableContainerWithLocation
                  loadData={verification.getVerificationRequestsDesktop}
                  requestReport={reports.requestVerificationRequestsDesktop}
                  wrappedComponentRef={innerComponent => {
                    // Forwarding ref to TableContainerWithLocation through 'withRouter' HOC
                    // This is the only way to forward ref with React Router 4
                    if (innerComponent) {
                      this.table = innerComponent;
                    }
                  }}>
                  <BootstrapTable
                    headerStyle={this.headerStyle}
                    version="4"
                    search
                    pagination
                    striped
                    hover
                    condensed
                    remote
                    exportCSV>
                    <TableHeaderColumn
                      dataFormat={this.viewFormatter}
                      dataField="verificationId"
                      width="50"
                      dataAlign="center">
                      View
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="name"
                      width="120"
                      isKey>
                      Organisation
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="accountId"
                      width="100">
                      Account ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="primaryContact"
                      width="120">
                      Primary Contact
                    </TableHeaderColumn>
                    <TableHeaderColumn dataSort dataField="address" width="80">
                      Address
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataFormat={dateFormatter}
                      dataField="registeredDate"
                      width="140">
                      Registered Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataFormat={dateFormatter}
                      dataField="requestedDate"
                      width="140">
                      Requested Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="verificationId"
                      dataFormat={this.approveRejectFormatter}
                      dataAlign="center"
                      width="200"
                      Actions>
                      Actions
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
